import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=4eeabfaf&scoped=true&"
var script = {}
import style0 from "./notice.vue?vue&type=style&index=0&id=4eeabfaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eeabfaf",
  null
  
)

export default component.exports